import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/styles/_global.scss";
import "@/styles/_variables.scss";
import Axios from "axios";
import Vuelidate from "vuelidate";
import VueAudio from "vue-audio";
import IdleVue from "idle-vue";

Vue.config.productionTip = false;

Vue.prototype.$axios = Axios;
Vue.prototype.$http = Axios;
Vue.use(BootstrapVue);
Vue.config.productionTip = false;
Vue.use(Vuelidate);
Vue.component("vue-audio", VueAudio);

const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 840000,
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
